import { Component, inject, viewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LayoutService } from 'src/app/services/layout/layout.service';
import { MobileMenuComponent } from 'src/app/components/header/mobile-menu/mobile-menu.component';
import { Path, RoutePath } from 'src/app/shared/route';
import { ContentfulService } from 'src/app/services/contentful/contentful.service';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './landing.component.html',
  standalone: true,
  selector: 'app-header-landing',
  imports: [RouterLink, MobileMenuComponent, MatMenuModule, MatButtonModule, MatIconModule, AsyncPipe, TranslatePipe],
  styles: `
  .nav-button {
    @apply transition-all;
    --mdc-text-button-label-text-color: rgb(var(--color-text));
    --mdc-text-button-label-text-weight: 500;
    --mdc-text-button-label-text-tracking: 0.5px;
    --mdc-text-button-label-text-size: 1rem;

    &:hover {
      --mdc-text-button-label-text-color: rgb(var(--color-primary));
    }

    @media (max-width: 1024px) {
      --mdc-text-button-label-text-size: 14px;
    }
  }

  .signup-btn {
    min-width: 101px;
    line-height: 18px;

    --mdc-filled-button-label-text-size: 13px;
    --mdc-filled-button-label-text-weight: 600;
    --mdc-filled-button-container-height: 30px;
    --mat-filled-button-horizontal-padding: 6px;
  }
  `,
})
export class HeaderLandingComponent {
  private readonly contenfulService = inject(ContentfulService);
  private readonly layoutService = inject(LayoutService);
  private readonly partnerTrigger = viewChild('partnerTrigger', { read: MatMenuTrigger });

  readonly contactPath = RoutePath.getPath(Path['contact-us']).fullPath;
  readonly helpPath = RoutePath.getPath(Path.help).fullPath;
  readonly demoPath = 'https://apps.shopify.com/goodchart';
  readonly privacyRoute = RoutePath.getPath(Path['privacy-policy']).fullPath;
  readonly blogPath = RoutePath.getPath(Path['blog']).fullPath;

  get showHeader() {
    return this.layoutService.showHeader;
  }

  // The menu panel stops click propagation to stay open, so in-app links close it themselves.
  closePartnerMenu() {
    this.partnerTrigger()?.closeMenu();
  }

  getButtonLabel(key: string) {
    return this.contenfulService.getButtonLabel(key);
  }
}
